const _ = require('lodash');
const axios = require('axios');

export default {
    _app : null,
    init() {
        this._app = document.querySelector('[data-vue-article-search]');
        if (!this._app) {
            return;
        }
        new Vue({
            el        : this._app,
            delimiters: ['[[', ']]'],
            data      : {
                loading               : true,
                display               : 'articles',
                search                : '',
                articles              : [],
                infoWindow            : [],
                activeInfoWindow      : null,
                pageIndex             : 0,
                productsPerPage       : 18,
                selectedSubCategories : [],
                selectedActivities    : [],
                selectedAttractions   : [],
                selectedMenuTags      : [],
                selectedDestinations  : [],
                selectedSeasons       : [],
                amounts               : {},
                categories            : [],
                subCategories         : [],
                municipalities        : [],
                menuTags              : {},
                seasons               : {},
                activities            : {},
                attractions           : {},
                destinations           : {},

            },
            created() {
                this.getQueryParamValues();
                this.getArticles();
            },
            mounted(){
                let categories = this.$el.dataset.categories;
                categories = JSON.parse(categories);
                this.menuTags = categories.menuTags;
                this.seasons = categories.seasons;
                this.attractions = categories.attractions;
                this.activities = categories.activities;
                this.destinations = categories.destinations;
            },

            methods: {
                toggleFavorites()
                {
                },

                getQueryParamValues() {
                    const params  = new URLSearchParams(window.location.search);
                    const search  = params.get('s');
                    const display = params.get('t');
                    this.search                 = search ? search.replace(/\s+/g,' ').trim() : '';
                    // this.display                = display ? display : 'articles';
                    this.selectedSubCategories  = params.getAll('kategori2[]');
                    this.selectedMenuTags   = params.getAll('menyTags[]');
                    this.selectedSeasons        = params.getAll('sesong[]');
                    this.selectedActivities     = params.getAll('aktivitet[]');
                    this.selectedAttractions    = params.getAll('attraksjon[]');
                    this.selectedDestinations    = params.getAll('destinasjoner[]');
                },

                getArticles()
                {
                    axios.get('/actions/visitmr/entries/articles?site='+CURRENT_SITE_ID)
                        .then(this.getArticles__callback)
                        .catch(function (error) { console.log(error)});
                },

                getArticles__callback(response)
                {
                    if (typeof response.data === 'object' && response.data !== null) {
                        this.articles = response.data;
                        this.filterHandler();
                    }

                    this.loading = false;
                },

                // Filters - shared //
                searchFilter(items) {

                    if (!this.search) {
                        return items;
                    }
                    return items.filter(item => {
                        // extended search
                        const titleMatch = item.title.match(new RegExp(this.search, 'gi'));
                        const teaserMatch = (item.teaser) ? item.teaser.match(new RegExp(this.search, 'gi')) : false;
                        const excerptMatch = (item.excerpt) ? item.excerpt.match(new RegExp(this.search, 'gi')) : false;
                        return titleMatch || teaserMatch || excerptMatch;
                    });
                },

                // Filters - articles
                menuTagsFilter(articles) {
                    if (!this.selectedMenuTags.length) {
                        return articles;
                    }
                    return articles.filter(article => {
                        return article.menuTags.some(r => this.selectedMenuTags.includes(r.toString()));
                    });
                },
                destinationsFilter(articles) {
                    if (!this.selectedDestinations.length) {
                        return articles;
                    }
                    return articles.filter(article => {
                        return article.destinations.some(r => this.selectedDestinations.includes(r.toString()));
                    });
                },
                seasonsFilter(articles) {
                    if (!this.selectedSeasons.length) {
                        return articles;
                    }
                    return articles.filter(article => {
                        return article.seasons.some(r => this.selectedSeasons.includes(r.toString()));
                    });
                },
                activitiesFilter(articles) {
                    if (!this.selectedActivities.length) {
                        return articles;
                    }
                    return articles.filter(article => {
                        return article.activities.some(r => this.selectedActivities.includes(r.toString()));
                    });

                },
                attractionsFilter(articles) {
                    if (!this.selectedAttractions.length) {
                        return articles;
                    }
                    return articles.filter(article => {
                        return article.attractions.some(r => this.selectedAttractions.includes(r.toString()));
                    });
                },
                filteredArticles(articles) {
                    let filteredArticles = this.searchFilter(articles);
                        filteredArticles = this.menuTagsFilter(filteredArticles);
                        filteredArticles = this.seasonsFilter(filteredArticles);
                        filteredArticles = this.activitiesFilter(filteredArticles);
                        filteredArticles = this.attractionsFilter(filteredArticles);
                        filteredArticles = this.destinationsFilter(filteredArticles);

                    return filteredArticles;
                },

                // General methods //
                goToPage(pageNumber) {
                    this.pageIndex = pageNumber;
                },
                displayPaginationNumber(number) {
                    if (this.pageIndex < 5 && number < 11) {
                        return true;
                    }

                    const  length = this.paginatedResults.length;

                    if (Math.abs(length - this.pageIndex) < 5 &&
                        Math.abs(length - number) < 11) {
                        return true;
                    }

                    return Math.abs(this.pageIndex - number) < 6
                },

                // Handlers //
                filterHandler() {
                    setTimeout(() => {
                        this.amounts = {};

                        for (const batch of this.paginatedResults) {
                            
                            for (const article of batch) {
                                for (let tag in this.menuTags) {
                                    tag = parseInt(tag);
                                    
                                    if (article['menuTags'].includes(tag)) {
                                        if (!this.amounts.hasOwnProperty(tag)) {
                                            this.amounts[tag] = 1;
                                        } else {
                                            this.amounts[tag] += 1;
                                        }
                                    }
                                }
                                for (let destination in this.destinations) {
                                    destination = parseInt(destination);
 
                                    if (article['destinations'].includes(destination)) {
                                        if (!this.amounts.hasOwnProperty(destination)) {
                                            this.amounts[destination] = 1;
                                        } else {
                                            this.amounts[destination] += 1;
                                        }
                                    }
                                }
                                for (let season in this.seasons) {
                                    season = parseInt(season);
                                    if (article['seasons'].includes(season)) {
                                        if (!this.amounts.hasOwnProperty(season)) {
                                            this.amounts[season] = 1;
                                        } else {
                                            this.amounts[season] += 1;
                                        }
                                    }
                                }
                                for (let activity in this.activities) {
                                    activity = parseInt(activity);
                                    if (article['activities'].includes(activity)) {
                                        if (!this.amounts.hasOwnProperty(activity)) {
                                            this.amounts[activity] = 1;
                                        } else {
                                            this.amounts[activity] += 1;
                                        }
                                    }
                                }
                                for (let attraction in this.attractions) {
                                    attraction = parseInt(attraction);
                                    if (article['attractions'].includes(attraction)) {
                                        if (!this.amounts.hasOwnProperty(attraction)) {
                                            this.amounts[attraction] = 1;
                                        } else {
                                            this.amounts[attraction] += 1;
                                        }
                                    }
                                }
                            }
                        }

                        this.queryParamsHandler();
                    });
                },
                queryParamsHandler() {

                    const length = 0;

                    let queryParams = `?t=${this.display}&`;
                    let counter     = 0;

                    if (this.search) {
                        queryParams += `s=${this.search}${length ? '&' : ''}`;
                    }

                    for (const subCategory of this.selectedSubCategories) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `kategori2[]=${subCategory}${and}`;
                        counter++;
                    }

                    for (const tag of this.selectedMenuTags) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `menyTags[]=${tag}${and}`;
                        counter++;
                    }
                    for (const season of this.selectedSeasons) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `sesong[]=${season}${and}`;
                        counter++;
                    }
                    for (const activity of this.selectedActivities) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `aktivitet[]=${activity}${and}`;
                        counter++;
                    }
                    for (const attraction of this.selectedAttractions) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `attraksjon[]=${attraction}${and}`;
                        counter++;
                    }
                    for (const d of this.selectedDestinations) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `destinasjoner[]=${d}${and}`;
                        counter++;
                    }

                    const origin   = window.location.origin;
                    const pathname = window.location.pathname;
                    let url = origin + pathname;
                    if (queryParams !== '?') {
                        url += queryParams;
                    }

                    // console.log(url);
                    history.replaceState({}, null, url);
                },

            },
            computed: {
                paginatedResults() {
                    this.pageIndex = 0;

                    const size = this.productsPerPage;
                    const articles = this.filteredArticles(this.articles);
                    const paginatedResults = [];

                    for (let i = 0; i < articles.length; i += size) {
                        paginatedResults.push(articles.slice(i, i + size));
                    }

                    return paginatedResults
                },
                amountOfPages(){
                    return this.paginatedResults.length;

                },
                amountOfArticles() {
                    let count = 0;
                    for (const batch of this.paginatedResults) {
                        count += batch.length;
                    }

                    return count;
                },
            },
            watch: {
                display: function(val) {
                    this.display   = val;
                    this.pageIndex = 0;
                }
            }
        });
    },
    reload() {
        this.init();
    },
    change() {
        this.init();
    }
}